module.exports = __webpack_public_path__ + "static/media/2022backtoschool_en.0b721567.png";